import { supabase } from './supabaseClient';

// Lista de espera del lanzamiento (sql/147). Solo las admins de Kontrol.

export const ESTADOS_LISTA = [
  { clave: 'nueva', txt: 'Nueva', color: '#6D28D9' },
  { clave: 'contactada', txt: 'Le escribí', color: '#B45309' },
  { clave: 'en_prueba', txt: 'En prueba', color: '#2563EB' },
  { clave: 'pago', txt: 'Pagó', color: '#047857' },
  { clave: 'no_interesa', txt: 'No le interesa', color: '#9CA3AF' },
  { clave: 'tester_aceptado', txt: '🧪 Tester aceptado', color: '#0D9488' },
  { clave: 'tester_no', txt: 'Tester: no quedó', color: '#9CA3AF' },
];

export const TIPOS_LISTA = { productos: 'Productos', servicios: 'Servicios', ambos: 'Los dos', por_empezar: 'Por empezar' };

export async function adminListaEspera() {
  const { data, error } = await supabase.rpc('admin_lista_espera');
  if (error) throw error;
  return data || [];
}

export async function adminActualizarLista(id, estado, notas = null) {
  const { data, error } = await supabase.rpc('admin_lista_espera_actualizar', { p_id: id, p_estado: estado, p_notas: notas });
  if (error) throw error;
  return data;
}

// Resumen para el panel: total, por tipo, de dónde vienen y qué les duele.
export function resumenLista(filas = []) {
  const vivas = filas.filter((f) => f.estado !== 'no_interesa' && f.estado !== 'tester_no');
  const contar = (campo) => {
    const m = {};
    vivas.forEach((f) => { const k = f[campo] || 'sin dato'; m[k] = (m[k] || 0) + 1; });
    return Object.entries(m).sort((a, b) => b[1] - a[1]);
  };
  const hace7 = Date.now() - 7 * 86400000;
  return {
    total: vivas.length,
    semana: vivas.filter((f) => new Date(f.creado_en).getTime() >= hace7).length,
    porTipo: contar('tipo'),
    porOrigen: contar('origen'),
    porDolor: contar('dolor'),
    testers: filas.filter((f) => f.registro === 'tester').length,
    testersAceptados: filas.filter((f) => f.estado === 'tester_aceptado').length,
  };
}

// Primer mensaje por WhatsApp (de tú, como Kontrol).
export function mensajeLista(f) {
  const nombre = String(f.nombre || '').split(' ')[0];
  return `¡Hola ${nombre}! 👋 Te escribe Merly, de Kontrol. Gracias por unirte a la lista de espera 💜\n\n`
    + 'El viernes 27 de noviembre te mando tu acceso para entrar antes que nadie a la prueba gratis (hasta el 14 de diciembre), '
    + 'y el 13 de diciembre abren los 25 cupos de precio fundador.\n\n'
    + `${f.dolor ? `Me contaste que lo que más te cuesta es: "${f.dolor}". ` : ''}¿Qué te gustaría resolver primero en tu negocio?`;
}

// Resumen corto de la postulación de un tester (sql/149).
export function resumenTester(r = {}) {
  return [r.antiguedad, (r.canales || []).join('/'), r.como_lleva, r.cantidad && `${r.cantidad} productos`,
    r.resolver && `quiere: ${r.resolver}`, r.compromiso === 'sí' ? '3 veces/semana ✓' : r.compromiso && '3 veces/semana: tal vez',
    r.plan && `plan: ${r.plan}`, r.testimonio, r.redes].filter(Boolean).join(' · ');
}

// Mensaje para avisarle a un tester que quedó seleccionado.
export function mensajeTesterAceptado(f) {
  const nombre = String(f.nombre || '').split(' ')[0];
  return `¡Hola ${nombre}! 🎉 Te escribe Merly, de Kontrol. ¡Quedaste como tester! Gracias por querer construir esto conmigo 💜\n\n`
    + 'Te paso tu enlace para crear tu cuenta: https://kontrol.automatikaia.com/?registro&o=tester\n'
    + 'Cuando la crees, avísame por aquí y la activo con todas las funciones gratis por noviembre y diciembre, y te aparto tu cupo de precio fundador.\n\n'
    + 'El acuerdo que aceptaste, por si quieres verlo: https://automatikaia.com/kontrol/testers/acuerdo/';
}

// CSV para respaldo o para importar contactos.
export function listaComoCSV(filas = []) {
  const col = ['creado_en', 'registro', 'nombre', 'whatsapp', 'pais', 'tipo', 'rubro', 'negocio', 'dolor', 'origen', 'estado', 'notas'];
  const esc = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;
  return [col.join(','), ...filas.map((f) => col.map((c) => esc(f[c])).join(','))].join('\n');
}
